
define('text!plugins/radio/setupTemplate.html',[],function () { return '';});

